'use client';

import { useSessionRefresh } from '@/features/auth/hooks/useSessionRefresh';

export const SessionRefresher = () => {
  useSessionRefresh();
  return null;
};
